module.exports = __webpack_public_path__ + "assets/img/ExpiredCouponMark.100c7b09.png";